module.exports = __webpack_public_path__ + "static/img/14001042.3cc1ecd0.png";